/* eslint-disable import/no-unresolved */
import React from 'react'
import { urls } from '@auteco/constants'
import Header from 'src/components/home/Header'
import Footer from 'src/components/home/Footer'
import luciaLogo from 'src/assets/images/lucia-logo.png'
import LuciaCube from './LuciaCube'

import {
  Form,
  Section,
  SectionContainer,
  Input,
  Button,
  Spinner,
  FieldError,
  Img,
  Centered,
  Error,
  CustomLink,
} from './styles'

import './LoginComponent.scss'

const SignIn = ({
  error,
  disabled,
  loading,
  title,
  buttonTittle,
  handlerSubmit,
  show,
  message,
  onChange,
  user,
  query,
  fieldErrors = {},
}) => (
  <div className="login-container">
    <Header />
    <Section>
      <SectionContainer>
        <Centered>
          <div className="lucia-brand">
            <LuciaCube size={72} className="lucia-brand__cube" />
            <Img alt="logo" src={luciaLogo} />
          </div>
        </Centered>
        <h3>{title}</h3>
        <Form onSubmit={handlerSubmit}>
          {!show && (
            <Centered>
              <p>{message}</p>
            </Centered>
          )}
          {!query && (
            <>
              <Input
                disabled={disabled}
                type="email"
                placeholder="Correo"
                id="email"
                name="email"
                autoComplete="email"
                value={user.correo || ''}
                $invalid={Boolean(fieldErrors.correo)}
                onChange={(event) => onChange(event, 'correo')}
              />
              {fieldErrors.correo && (
                <FieldError>{fieldErrors.correo}</FieldError>
              )}
            </>
          )}
          {(show || query) && (
            <>
              <Input
                disabled={disabled}
                type="password"
                placeholder="Contraseña"
                id="password"
                name="password"
                autoComplete="current-password"
                value={user.clave || ''}
                $invalid={Boolean(fieldErrors.clave)}
                onChange={(event) => onChange(event, 'clave')}
              />
              {fieldErrors.clave && (
                <FieldError>{fieldErrors.clave}</FieldError>
              )}
            </>
          )}
          <Button type="submit" disabled={disabled || loading}>
            {loading && <Spinner aria-hidden />}
            {loading ? 'Ingresando…' : buttonTittle}
          </Button>
          <Centered>
            <span className="login-recaptcha-note">
              This site is protected by reCAPTCHA and the Google
              <a href={urls.PRIVACITY_POL}>Privacy Policy</a> and
              <a href={urls.GOOGLE_TERMS}>Terms of Service</a> apply.
            </span>
          </Centered>
        </Form>
        <Centered>{error && <Error role="alert">{error}</Error>}</Centered>
      </SectionContainer>
      {show && (
        <Centered>
          <CustomLink to="/credenciales/recuperacion">
            Olvidé mi contraseña
          </CustomLink>
        </Centered>
      )}
    </Section>
    <Footer />
  </div>
)

export default SignIn
